<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'EDM Send List', to: { path: '/edm-send-list' } },
        { name: 'Edit', to: { path: '/edm-send-list/edit' } },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>編輯Edit</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <EDMCreateEdit></EDMCreateEdit>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import EDMCreateEdit from '@/views/K__eNewsletterEDMlist/c/EDMCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    EDMCreateEdit,
  },
  methods: {
    cancelHandler() {
      this.$router.push('/edm-send-list');
    },
    saveHandler() {
      this.$router.push('/edm-send-list');
    },
  },
};
</script>

<style></style>
